// extracted by mini-css-extract-plugin
export default {"dragBox":"DragNDrop_dragBox__gHu-9","dndBox":"DragNDrop_dndBox__8uSlJ"};